@if (headerData) {
	<uc-main-header
		[heading]="headerData.title"
		[description]="headerData.description"
		[backgroundStyle]="headerData.backgroundStyle"
	>
		<uc-category-header-navigation />
	</uc-main-header>
}

<div class="container pt-4 sm:pt-0">
	<div class="divider">
		<uc-heading
			[headingTitle]="headingContent?.title"
			[description]="headingContent?.description"
		/>
	</div>

	<!-- snigel google ads -->
	<div class="divider">
		<div class="sm:hidden">
			<div id="adngin-incontent_1_mob-0" class="mx-auto incontent_1_mob-0"></div>
		</div>

		<div class="hidden sm:block">
			<div id="adngin-incontent_1_dskt-0" class="mx-auto incontent_1_dskt-0"></div>
		</div>
	</div>
</div>

@if (guides$ | async; as guides) {
	<div class="container">
		<section class="bg-white divider">
			<h2 class="secondary-header">
				{{ subtitle }}
			</h2>
			<div class="grid gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
				@for (guide of guides; track guide) {
					<uc-guides-card [categoryUrl]="categoryUrl" [guide]="guide" />
				}
			</div>
		</section>
		<!-- snigel google ads -->
		<div class="divider !border-b-0">
			<div class="hidden sm:block">
				<div
					id="adngin-incontent_2_dskt-0"
					class="mx-auto incontent_1_dskt-0"
				></div>
			</div>
			<div class="sm:hidden">
				<div
					id="adngin-incontent_2_mob-0"
					class="mx-auto incontent_1_mob-0"
				></div>
			</div>
		</div>
		<uc-sticky-lead-bar-renderer leadType="BOOK_EVENT" colorScheme="ROSE" />
	</div>
}

<uc-recommended-unis-carousel />
